<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import opersonel from "@/models/opersonel";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, opersonel],
  page: {
    title: "Kullanıcılar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit,treeselect
  },
  data() {
    return {
      title: "Kullanıcılar",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        }, 
        {
          text: "Kullanıcılar",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      PasswordModalOpen: false,
      SifreData: {
        Email: null,
        Password: null,
        ConfirmPassword: null,
      },
      Filter: {
        Birimid: null,
        Personeltipid: null,
        Adsoyad: null,
        Eposta: null,
        Telefon: null,
        Tckimlikno: null,


      }
    };
  },

  computed: {
    AdminYetkisi() {
      return this.APPLICATION_TYPE == 1 &&
        this.UserRolles &&
        this.UserRolles.some((item) => item === "SuperAdmin" || item === "TlpAdmin");
    },
  },

  methods: {
    SifreBelirlemeAc(Data) {
      this.SifreData = { Email: Data.Eposta, Password: null, ConfirmPassword: null };
      this.PasswordModalOpen = true;
    },
    SifreBelirlemeKaydet() {
      if (!this.SifreData.Password || this.SifreData.Password.length < 6) {
        this.$toast.error("Şifre en az 6 karakter olmalıdır.");
        return;
      }
      if (this.SifreData.Password != this.SifreData.ConfirmPassword) {
        this.$toast.error("Şifreler aynı olmalıdır.");
        return;
      }
      this.ActionsAdminSetPassword({ Email: this.SifreData.Email, Password: this.SifreData.Password }).then((res) => {
        if (res.Succeeded == true) {
          this.$toast.success(res.Message);
          this.PasswordModalOpen = false;
        } else {
          this.$toast.error(res.Message);
        }
      });
    },
    EpostaOnayla(Data) {
      this.ActionsAdminConfirmEmail(Data.Eposta).then((res) => {
        if (res.Succeeded == true) {
          this.$toast.success(res.Message);
        } else {
          this.$toast.error(res.Message);
        }
      });
    },
    Get() {
      
      var Filter = "&Asc="
      if (this.Filter.Birimid != null && this.Filter.Birimid != "") {
        Filter += "&Birimid=" + this.Filter.Birimid
      }
      if (this.Filter.Personeltipid != null && this.Filter.Personeltipid != "") {
        Filter += "&Personeltipid=" + this.Filter.Personeltipid
      }
      if (this.Filter.Adsoyad != null && this.Filter.Adsoyad != "") {
        Filter += "&Adsoyad=" + this.Filter.Adsoyad
      }
      if (this.Filter.Eposta != null && this.Filter.Eposta != "") {
        Filter += "&Eposta=" + this.Filter.Eposta
      }
      if (this.Filter.Telefon != null && this.Filter.Telefon != "") {
        Filter += "&Telefon=" + this.Filter.Telefon
      }
      if (this.Filter.Tckimlikno != null && this.Filter.Tckimlikno != "") {
        Filter += "&Tckimlikno=" + this.Filter.Tckimlikno
      }




      this.ActionsFilterGet({
        Service: "opersonel",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
  },
};
</script>
 
<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <button
                    type="button"
                    class="btn btn-primary btn-rounded mb-2 me-2"
                    v-b-modal.opersonel
                    @click="(DataUpdate = opersonelData), (AddEdit = 'Add')"
                  >
                    <i class="mdi mdi-plus me-1"></i>
                    Yeni Kayıt Ekle
                  </button>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>

              
              <div class="accordion mb-3"  >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">

                        
                        <b-form-group class="col-lg-3" label="Ad Soyad" > <b-form-input  v-model="Filter.Adsoyad"  ></b-form-input></b-form-group>
                        <b-form-group class="col-lg-3" label="E-Posta" > <b-form-input  v-model="Filter.Eposta"  ></b-form-input></b-form-group>
                        <b-form-group class="col-lg-3" label="Telefon" > <b-form-input  v-model="Filter.Telefon"  ></b-form-input></b-form-group>
                        <b-form-group class="col-lg-3" label="T.C. Kimlik No" > <b-form-input  v-model="Filter.Tckimlikno"  ></b-form-input></b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Birimid.FieldTitle"
                          :key="Filter.Birimid">
                          <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Birimid" />
                          <treeselect-value :value="Filter.Birimid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Personeltipid.FieldTitle"
                          :key="Filter.Personeltipid">
                          <treeselect :multiple="false" :options="FormDataType.Personeltipid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Personeltipid" />
                          <treeselect-value :value="Filter.Personeltipid" />
                        </b-form-group>
 

                        <div class="col-lg-4">
                          <button class="btn btn-success mt-4" data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Ad Soyad</th>
                      <th>Birim</th>
                      <th>E-Posta</th>
                      <th>Telefon</th>
                      <th>Kullanıcı Tipi</th>
                      <th>T.C. Kimlik No</th>
                      <th    class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          " >İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Adsoyad }}</th>
                      <td>{{ Data.Birim }}</td> 
                      <td>{{ Data.Eposta }}</td> 
                      <td>{{ Data.Telefon }}</td> 
                      <td>{{ Data.Personeltip }}</td> 
                      <td>{{ Data.Tckimlikno }}</td> 
                      <td>
                        <div
                          class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <b-button-group>
                            <b-button
                              v-b-tooltip.hover
                              title="Düzenle"
                              variant="success"
                              v-b-modal.opersonel
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                              ><i class="far fa-edit"></i
                            ></b-button>
                            <b-button
                              v-if="AdminYetkisi"
                              v-b-tooltip.hover
                              title="Şifre Belirle"
                              variant="warning"
                              @click="SifreBelirlemeAc(Data)"
                              ><i class="fas fa-key"></i
                            ></b-button>
                            <b-button
                              v-if="AdminYetkisi"
                              v-b-tooltip.hover
                              title="E-postayı Onayla"
                              variant="info"
                              @click="EpostaOnayla(Data)"
                              ><i class="fas fa-envelope-open-text"></i
                            ></b-button>
                            <b-button
                              variant="danger"
                              v-b-tooltip.hover
                              title="Sil"
                              @click="Delete('opersonel', Data.Id)"
                              ><i class="far fa-trash-alt"></i
                            ></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />

      <b-modal v-model="PasswordModalOpen" title="Şifre Belirle" hide-footer>
        <Form @submit.prevent="SifreBelirlemeKaydet">
          <div class="row">
            <b-form-group class="col-lg-12" label="E-Posta">
              <b-form-input :model-value="SifreData.Email" disabled></b-form-input>
            </b-form-group>
            <b-form-group class="col-lg-12" label="Yeni Şifre">
              <b-form-input v-model="SifreData.Password" type="password"></b-form-input>
            </b-form-group>
            <b-form-group class="col-lg-12" label="Yeni Şifre (Tekrar)">
              <b-form-input v-model="SifreData.ConfirmPassword" type="password"></b-form-input>
            </b-form-group>
          </div>
          <button class="btn btn-primary" type="submit">
            Kaydet
          </button>
        </Form>
      </b-modal>
    </Layout>
  </Loader>
</template>
